import { makeStyles, lighten, darken } from "@material-ui/core";

export const DelcoteAsbestosStyle = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        margin: "-0.75rem 0",
        "& > div": {
            display: "flex",
            flexDirection: "column",
            margin: "0.75rem -0.75rem",
            "& > div": {
                display: "flex",
                flex: "1",
                flexDirection: "column",
                margin: "0 0.75rem",
            },
            [theme.breakpoints.up("md")]: {
                flexDirection: "row",
            },
        },
    },
    editsContainer: {
        display: "flex",
        flexWrap: "wrap",
    },
    selectContainer: {
        display: "flex",
        flexDirection: "column",
    },
    textContainer: {
        display: "flex",
        flexDirection: "column",
        "& p": {
            margin: "0.5rem 0",
        },
    },
    delcotedelglazeimage: {
        backgroundSize: "contain",
        height: "100%",
        minHeight: "230px",
        width: "auto",
    },
}));
